import { render } from "./SplitProvider.vue?vue&type=template&id=812c0e5e"
import script from "./SplitProvider.vue?vue&type=script&lang=js"
export * from "./SplitProvider.vue?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__